import { jsx as l } from "react/jsx-runtime";
const o = (h) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M33 6.01h-2v52h2v-52ZM16.725 18.963a6.513 6.513 0 0 1-6.506-6.505 6.513 6.513 0 0 1 6.506-6.505 6.513 6.513 0 0 1 6.505 6.505 6.513 6.513 0 0 1-6.505 6.505Zm0-10.01a3.51 3.51 0 0 0-3.506 3.505 3.51 3.51 0 0 0 3.506 3.505 3.51 3.51 0 0 0 3.505-3.505 3.51 3.51 0 0 0-3.505-3.505ZM46.564 19.002a6.513 6.513 0 0 1-6.506-6.505 6.513 6.513 0 0 1 6.506-6.506 6.513 6.513 0 0 1 6.505 6.506 6.513 6.513 0 0 1-6.505 6.505Zm0-10.01a3.51 3.51 0 0 0-3.506 3.505 3.51 3.51 0 0 0 3.506 3.505 3.51 3.51 0 0 0 3.505-3.505 3.51 3.51 0 0 0-3.505-3.506ZM19.064 55.099h-4.451a.259.259 0 0 1-.259-.248l-.81-17.547h-2.99a.26.26 0 0 1-.26-.257l-.068-12.822 6.499-1.722 6.504 1.724v13.077h-3.324l-.82 17.784 3.04-.815.645-13.969h3.46V21.92l-9.505-2.52-9.51 2.521.079 15.143a3.267 3.267 0 0 0 3.26 3.241h.126l.677 14.685a3.254 3.254 0 0 0 3.256 3.11h5.255l-.804-3ZM48.448 55.172h-3.506a.29.29 0 0 1-.291-.29V44.63h-4.466l3.144-13.05-.02-8.184 3.222-.854 3.226.855v8.049L52.94 44.63h-4.465v10.45l3-.803V47.63h5.276l-3.995-16.541v-10l-6.226-1.65-6.229 1.65.026 10.139-3.952 16.402h5.275v7.252a3.294 3.294 0 0 0 3.29 3.29h4.311l-.804-3Z"
      }
    )
  }
);
export {
  o as Toilet
};
